export default {"src":"/_next/static/media/car.d7616e85.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};